import React from 'react'
import axios from 'axios';
import SortableItem, { StaticItem } from './SortableItem'

const COLUMNS = [
  { key: 'is_senior', label: 'Is Senior', type: 'boolean' },
  { key: 'is_elementary', label: 'Is Elementary', type: 'boolean' },
  { key: 'is_holiday', label: 'Is For Gifts', type: 'boolean' },
  { key: 'name', label: 'Name', type: 'string' },
  { key: 'price_with', label: 'Price with', type: 'number' },
  { key: 'price_without', label: 'Price without', type: 'number' },
  { key: 'image_count', label: 'Image count', type: 'number' },
  { key: 'css_name', label: 'CSS Name', type: 'string' },
]

// null/undefined always sort last, regardless of direction
const comparator = (key, type, dir) => (a, b) => {
  const av = a[key]
  const bv = b[key]
  if (av == null && bv == null) return 0
  if (av == null) return 1
  if (bv == null) return -1

  let result
  if (type === 'number') result = parseFloat(av) - parseFloat(bv)
  else if (type === 'boolean') result = (bv ? 1 : 0) - (av ? 1 : 0) // Yes first on asc
  else result = String(av).localeCompare(String(bv))

  return dir === 'desc' ? -result : result
}

export default class SortableAddons extends React.Component {

  // `items` is the CANONICAL manual order — it is what the reorder timer
  // persists as `position`. Column sorting is display-only (sortBy/sortDir)
  // and must never touch `items`, or clicking a header would silently rewrite
  // every addon's position two seconds later.
  state = {
    items: this.props.items,
    sortBy: null,
    sortDir: 'asc',
  };

  onSortItems = (items) => {
    this.setState({
      items: items
    });
  }

  // asc -> desc -> back to manual (drag) order
  onHeaderClick = (key) => {
    this.setState(({ sortBy, sortDir }) => {
      if (sortBy !== key) return { sortBy: key, sortDir: 'asc' }
      if (sortDir === 'asc') return { sortBy: key, sortDir: 'desc' }
      return { sortBy: null, sortDir: 'asc' }
    })
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      // Only persist while in manual order — a column-sorted view must never
      // become the stored position order.
      if (this.state.sortBy !== null) return

      axios.patch("/admin/addons/reorder", {
        items: this.state.items
      })
    }, 2000)
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  render() {
    const { items, sortBy, sortDir } = this.state;

    const column = COLUMNS.find((c) => c.key === sortBy)
    const displayedItems = column ? [...items].sort(comparator(column.key, column.type, sortDir)) : items

    // Drag-to-reorder only makes sense in manual order; while a column sort is
    // active the rows render static so a drag can't fight the sort.
    var listItems = displayedItems.map((item, i) => {
      if (sortBy !== null) return <StaticItem key={item.id} item={item} />

      return (
        <SortableItem
          key={i}
          onSortItems={this.onSortItems}
          items={items}
          sortId={i}
          item={item}
        />
      )
    })

    return (
      <React.Fragment>
        <p style={{ color: '#666', fontSize: '0.9rem' }}>
          {sortBy === null
            ? 'Drag rows to reorder the customer-facing display. Click a column header to sort.'
            : 'Sorted view — drag-to-reorder is paused. Click the sorted header again to cycle back to manual order.'}
        </p>
        <table style={{ minWidth: '60%' }}>
          <thead>
          <tr>
            {COLUMNS.map(({ key, label }) => (
              <th
                key={key}
                onClick={() => this.onHeaderClick(key)}
                style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                title="Click to sort (click again to reverse, a third time for manual order)"
              >
                {label}
                {sortBy === key ? (sortDir === 'asc' ? ' ▲' : ' ▼') : ''}
              </th>
            ))}
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
            {listItems}
          </tbody>
        </table>
      </React.Fragment>
    )
  }
}
